//
// Utility methods for fetching wistia streaming video data.
//mskadd9scy
//Attempts to retrieve a wistia video's JSON blob. If unsuccessful, moves on to next. If successful, uses that json blob info to load and populate the video's thumbnail.
const getWistiaVideo = async function (id) {
  try {
    let url = new URL(`https://fast.wistia.com/embed/medias/${id}.json`)
    let theresp = await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => {
      if (response.status !== 200) {
        throw new Error(
          `wistia server returned bad response code: ${response.status}`,
        )
      }
      return response.json().then(data => {
        if (data.error === true) {
          throw new Error(`wistia cannot find this videoID.`)
        } else {
          data.embedID = id
          return data
        }
      })
    })
    //If we got our video json, then keep going by adding the additional needed video props.
    let obj = await getWistiaExtraData(theresp)
    return obj
  } catch (err) {
    console.log(`issue getting wistia vid. ${err}`)
  }
}

//get video thumb, then append needed generic prop.
const getWistiaExtraData = async function (video) {
  video.thumbURL = await getThumb(video)
  video.active = false
  return video
}

//Get wistia video thumbnail image URL.
const getThumb = obj => {
  return new Promise(function (res, rej) {
    let ret = ''
    obj.media.assets.forEach(function (asset) {
      if (asset.type.indexOf('image') > -1) {
        ret = asset.url.split('.bin').join('.jpg?image_crop_resized=120x100')
      }
    })
    res(ret)
  })
}

export const parseVideoIDs = function (videoIdFromBeaker) {
  let ret = []
  try {
    let theIDs = videoIdFromBeaker.split(' ').join('').split(',')
    ret = theIDs
  } catch (e) {
    console.log(
      `Error getting video ID(s). This is probably an incorrect beaker entry. Error is: ${e}`,
    )
  }
  return ret
}

//Gets array of videoIDs as arg, requests data of each from wistia and filters out videos that cannot be found.
//Returns array of video info json blobs.
export const getWistiaPlaylist = async videoIDs => {
  let vids = await Promise.all(videoIDs.map(item => getWistiaVideo(item))).then(
    function (data) {
      //remove errored video request results.
      return data
        .filter(function (item) {
          return typeof item === 'object'
        })
        .map(function (item) {
          let aspect = false
          try {
            if (item.media.assets[0].height > item.media.assets[0].width) {
              aspect = true
            }
          } catch (e) {}
          item.aspectRatioIsRealTall = aspect
          return item
        })
    },
  )

  return vids
}
